import {Component, inject} from '@angular/core';
import {MatInput, MatLabel} from "@angular/material/input";
import {MatTab, MatTabChangeEvent, MatTabGroup} from "@angular/material/tabs";
import {MatFormField} from "@angular/material/form-field";
import {MatButton} from "@angular/material/button";
import {ProductCardsDefectsService} from "../../../services/product-cards-defects.service";
import {FormsModule} from "@angular/forms";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {ProductCardDefectDialogData} from "../../../types/product-card-defect.types";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {productCardDefectModalName} from "./configs/product-card-defect-config";
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";

@Component({
  selector: 'app-product-card-defect-modal',
  imports: [
    BaseModalComponent,
    MatFormField,
    MatInput,
    MatLabel,
    MatTab,
    MatTabGroup,
    MatButton,
    FormsModule,
    MatOption,
    MatSelect
  ],
  templateUrl: './product-card-defect-modal.component.html',
  styleUrl: './product-card-defect-modal.component.scss'
})
export class ProductCardDefectModalComponent extends BaseModalComponent {
  public productCardDefectDialogData = inject<ProductCardDefectDialogData>(MAT_DIALOG_DATA);
  private productCardsDefectsService: ProductCardsDefectsService = inject(ProductCardsDefectsService);

  public name: string = '';
  public selectedDefect: number = 0;
  public hasDefects: boolean = false;
  private selectedTab: number = 0;

  public override async ngOnInit(): Promise<void> {
    this.modalStatesService.openModal(productCardDefectModalName);
    this.hasDefects = !!this.productCardDefectDialogData.defects.length;
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(productCardDefectModalName);
  }

  public handleTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
    this.name = '';
    this.selectedDefect = 0;
  }

  public async handleBtn(): Promise<void> {
    const actions = [
      () => this.productCardsDefectsService.createProductCardsDefect({
        productCardId: this.productCardDefectDialogData.productCardId,
        title: this.name
      }),
      () => this.productCardsDefectsService.updateProductCardsDefect({
        id: this.selectedDefect,
        value: this.name
      }),
      () => this.productCardsDefectsService.deleteProductCardsDefect(this.selectedDefect)
    ];

    const action = actions[this.selectedTab];
    await action().finally(() => this.closeDialog('cancel'));
  }

  public getBtnText(): string {
    const labels = [ 'Создать', 'Обновить', 'Удалить' ];
    return labels[this.selectedTab] || 'Удалить';
  }

  public isDisabledBtn(): boolean {
    return this.selectedTab === 2 ? !this.selectedDefect : !this.name;
  }
}
